
import { useState, useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import Products from './components/Products';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';

const HomePage = () => {
  useEffect(() => {
    // Update page title and meta description for home page
    document.title = 'WOTECH - Enterprise IT Solutions & Automation Services | Delaware USA';
    
    // Add structured data for WebPage
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "WOTECH - Enterprise IT Solutions",
      "description": "Leading provider of enterprise IT solutions including ManageEngine, AutomMate, and Zoho One implementations.",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}`,
      "mainEntity": {
        "@type": "Organization",
        "name": "WOTECH",
        "description": "Enterprise IT solutions and automation services provider"
      },
      "breadcrumb": {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}`
          }
        ]
      }
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(structuredData);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <Services />
        <Products />
        <About />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
